import { colorVarAlpha, type Color } from '@salestrak/ui'

/** The hues this palette cycles, in order. */
const PALETTE_HUES = [
  'purple',
  'teal',
  'blue',
  'yellow',
  'red',
  'green',
  'orange',
  'light-purple',
  'dark-grey',
  'violet',
] as const satisfies readonly Color[]

/**
 * The 10-color chart palette as `var()` strings. These feed SVG `fill`,
 * `stroke` and `stop-color`, which are CSS properties — they resolve the var
 * and re-resolve it on a theme flip, so the palette is static data, not state.
 * `gradient` is the same hue at 40%, for the inner stop of a radial fill.
 */
export const CHART_PALETTE: readonly string[] = PALETTE_HUES.map(
  (hue) => `var(--${hue})`,
)

export const CHART_PALETTE_WITH_GRADIENT: readonly {
  color: string
  gradient: string
}[] = PALETTE_HUES.map((hue) => ({
  color: `var(--${hue})`,
  gradient: colorVarAlpha(hue, 0.4),
}))

/** Color dot inline style helper */
export const colorDotStyle = (color: string) => ({ backgroundColor: color, flexShrink: 0 } as const)

/** Battery chart segment inline style helper */
export const batterySegmentStyle = (flex: number, color: string) => ({ flex, backgroundColor: color } as const)
